module.exports = __webpack_public_path__ + "img/user.b5c4f851.svg";